export const onDomReady = (callback) => {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => callback(), { once: true, passive: true });
	} else {
		callback();
	}
};


